<p class="message">{{ data.message }}</p>
<div class="buttons-container">
  <button [mat-dialog-close]="false" mat-raised-button type="button" data-testid="btn-dialog-cancel">
    {{ 'BUTTONS.CANCEL' | translate }}
  </button>
  <button [mat-dialog-close]="true" mat-raised-button color="warn" type="button" data-testid="btn-dialog-confirm">
    {{ 'BUTTONS.CONFIRM' | translate }}
  </button>
</div>
